import { render, staticRenderFns } from "./FakturPajakUpload.vue?vue&type=template&id=b7b32c24&scoped=true"
import script from "./FakturPajakUpload.vue?vue&type=script&lang=js"
export * from "./FakturPajakUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b32c24",
  null
  
)

export default component.exports